import React from 'react';
import BannerOdd from './BannerOdd';

export default function BannerOddsOverlay(props) {
    const data = props.data;

    const bet = data.bet;
    let [team1, team2] = ['', ''];
    
    if (data.desc.includes(' - ')) {
        const parts = data.desc.split(' - ');
        [team1, team2] = [parts[0], parts[1]];
    } else {
        team1 = data.desc;
    }

    return (
        <div className="xs_bannerOddsOverlay min-h-10 grid grid-cols-12 items-center p-1 bg-gradient-to-b from-shadow-start to-shadow-end rounded-b-lg">
            <div className="col-start-1 col-end-5 flex flex-col align-center justify-evenly">
                <span className="text-fs1 font-medium uppercase text-shadow-contrast-1 truncate overflow-hidden">{team1}</span>
                {team2.length > 0 &&
                    <span className="text-fs1 font-medium uppercase text-shadow-contrast-1 truncate overflow-hidden">{team2}</span>
                }
                {data.text &&
                    <span className="text-fs1 text-shadow-contrast-1 truncate overflow-hidden">{data.text}</span>
                }
            </div>
            <div className="col-start-5 col-end-13 overflow-hidden">
                <div className="w-full h-10 flex items-center justify-end">
                    {bet.odds.map((odd, i) =>
                        <BannerOdd key={odd.id} data={odd} />
                    )}
                </div>
            </div>
        </div>
    );
}
